import { assetUrl } from "./backend";

/** 缩略图文件名后缀（原图不改，另存为 stem + 后缀 + .jpg） */
export const THUMB_MARK = "_缩略图";

const IMAGE_EXT = /\.(jpe?g|png|gif|webp|bmp)$/i;

export function isThumbPath(relativePath: string): boolean {
  return relativePath.includes(THUMB_MARK);
}

/** 相对路径 → 缩略图相对路径（统一输出 .jpg） */
export function thumbPath(relativePath: string): string {
  const p = relativePath.replace(/^\/+/, "");
  if (!p || isThumbPath(p)) return p;
  const dot = p.lastIndexOf(".");
  if (dot < 0) return `${p}${THUMB_MARK}.jpg`;
  const stem = p.slice(0, dot);
  const ext = p.slice(dot);
  if (IMAGE_EXT.test(ext)) return `${stem}${THUMB_MARK}.jpg`;
  return `${stem}${THUMB_MARK}${ext}`;
}

export function thumbUrl(relativePath: string): string {
  return assetUrl(thumbPath(relativePath));
}

/** 从 assetUrl 反推相对路径 */
export function relativePathFromAssetUrl(url: string): string | null {
  if (!url) return null;
  try {
    const u = new URL(url, typeof window !== "undefined" ? window.location.origin : "http://local");
    let path = u.pathname.replace(/^\/+/, "");
    if (path.startsWith("api/")) path = path.slice(4);
    return path || null;
  } catch {
    return null;
  }
}

export type PhotoUrls = {
  full: string;
  thumb: string;
};

export function photoUrlsFromRelative(relativePath: string): PhotoUrls {
  return {
    full: assetUrl(relativePath),
    thumb: thumbUrl(relativePath),
  };
}
